export default __webpack_public_path__ + "static/media/vehiculo-puerta.cc72851a.svg";